var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',{attrs:{"is-loading":_vm.isLoading,"background-url":_vm.backgroundUrl}},[_vm._t("title"),_vm._v(" "),_c('Content',[_vm._t("switcher"),_vm._v(" "),_c('Scroller',[_c('Prices',{attrs:{"is-loading":_vm.isLoading}},[_vm._t("prices")],2)],1)],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }